import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import TablePaginationActions from "../../../../../../globals/components/TablePaginationActions";
import { CarrierTabEmptyRow } from "./carrierTabTablePrimitives";

export default function CarrierLimitsTabPanel({ vm }) {
  const {
    handleOpenLimitDialog,
    rowsPerPageLimits,
    handleEditLimitClick,
    handleDeleteLimit,
    handleChangePageLimits,
    handleChangeRowsPerPageLimits,
    paginationSx,
    formatAmount,
    formatDate,
    carrierLimits,
    headerRowSx,
    pageLimits,
    tableCardSx,
  } = vm;

  const slice = carrierLimits.slice(
    pageLimits * rowsPerPageLimits,
    pageLimits * rowsPerPageLimits + rowsPerPageLimits,
  );

  const renderBody =
    carrierLimits.length === 0 ? (
      <CarrierTabEmptyRow colSpan={4} message="No limits found." />
    ) : (
      slice.map((limit) => (
        <TableRow key={limit.limit_id}>
          <TableCell>{limit.bond_type_display?.type || "N/A"}</TableCell>
          <TableCell align="right">${formatAmount(limit.bond_amount)}</TableCell>
          <TableCell align="right">{formatDate(limit.effective_date)}</TableCell>
          <TableCell align="center">
            <IconButton color="primary" onClick={() => handleEditLimitClick(limit.limit_id)}>
              <EditIcon />
            </IconButton>
            <IconButton color="error" onClick={() => handleDeleteLimit(limit.limit_id)}>
              <DeleteIcon />
            </IconButton>
          </TableCell>
        </TableRow>
      ))
    );

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
        <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleOpenLimitDialog}>
          Add Limit
        </Button>
      </Box>
      <TableContainer component={Paper} sx={tableCardSx}>
        <Table>
          <TableHead>
            <TableRow sx={headerRowSx}>
              <TableCell>Bond Type</TableCell>
              <TableCell align="right">Authority Limit</TableCell>
              <TableCell align="right">Effective Date</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{renderBody}</TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        ActionsComponent={TablePaginationActions}
        component="div"
        count={carrierLimits.length}
        page={pageLimits}
        onPageChange={handleChangePageLimits}
        rowsPerPage={rowsPerPageLimits}
        onRowsPerPageChange={handleChangeRowsPerPageLimits}
        rowsPerPageOptions={[5, 10, 25, 50]}
        sx={paginationSx}
      />
    </>
  );
}

CarrierLimitsTabPanel.propTypes = {
  vm: PropTypes.object.isRequired,
};
